module.exports = __webpack_public_path__ + "img/1744.ffbcd3e2.jpg";